import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Box, colors, Grid, Typography} from "@material-ui/core";

import { ProfileAction } from "../../../components/profile-action/ProfileAction";
import {APP_NAME} from "../../../settings/constants";

const useStyles = makeStyles((theme) => ({
  header: {
    position: "fixed",
    backgroundColor: theme.palette.secondary.main,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    zIndex: 2,

    "& .headerContent": {
      height: 50,

      [theme.breakpoints.down("xs")]: {
        padding: "0 20px",
      },

      "& .appLogo": {
        display: "flex",
        alignItems: "center",

        "& img": {
          height: 20,
          width: 36,
        },
        "& span.appTitle": {
          fontSize: "1.1rem",
          fontWeight: theme.typography.fontWeightMedium,
          color: colors.common.white,
        },
        "& span.appDecoration": {
          backgroundColor: colors.common.white,
          color: theme.palette.secondary.main,
          fontSize: "0.64rem",
          fontWeight: theme.typography.fontWeightBold,
          marginLeft: "8px",

          borderRadius: "4px",
          padding: "4px 8px 2px 7px",
          textTransform: "uppercase",
        },
      },
    },
  },
}));

export const Header = (props: any) => {
  const classes = useStyles(props);

  return (
    <Grid container className={classes.header}>
      <Grid item xs={12}>
        <Box
          display="flex"
          flexWrap="nowrap"
          alignItems="center"
          justifyContent="space-between"
          className="headerContent"
        >
          <Box className="appLogo">
            {/*<img src={process.env.PUBLIC_URL + "/logo_white.svg"} alt="" />*/}
            <Typography component="span" className="appTitle">
              {APP_NAME}
            </Typography>
            <Typography component="span" className="appDecoration">
              Admin
            </Typography>
          </Box>
          <ProfileAction />
        </Box>
      </Grid>
    </Grid>
  );
};
